import { koComponent } from '../../ko-utils';
import { showToast } from '../page';
// import languages from "legacy/utils/languages";

class ImportExport {
    constructor(params) {
        this.entityTypeName = params.entityTypeName;
        this.entityId = params.entityId;
        this.doneCallback = params.doneCallback;

        this.isSubmitting = ko.observable(false);

        this.supportedLanguages = ko.observableArray(window.auth.project.SupportedLanguages);

        this.exportLanguage = ko.observable();

        this.exportUrl = ko.computed(() => {
            return `/api/v1/export/${auth.project.UniqueCode}/${this.entityTypeName}/${this.entityId}?lang=${this.exportLanguage()}`;
        })

        this.importLanguage = ko.observable(window.auth.project.SupportedLanguages.length > 1 ? window.auth.project.SupportedLanguages[1] : null);

        this.importFile = ko.observable();

        this.importEnabled = ko.computed(() => {
            return !this.isSubmitting() && !!this.importFile();
        })

        this.entityNameHuman = ko.computed(() => {
            if (this.entityTypeName == 'tour') {
                return 'tour';
            } else {
                return 'hints group'
            }
        });

        // this.rootPageParent = rootPageParent;
    }

    importFileSelected(_, e) {
        const file = e.target.files[0];

        if (file) {
            if (!file.type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                return; // todo: error
            }

            this.importFile(file);
        }
    }

    startImport() {
        if (confirm(`Do you want to overwrite the '${this.importLanguage()}' version of this ${this.entityNameHuman()}?`)) {
            this.isSubmitting(true);

            var fd = new FormData();
            fd.append('file', this.importFile());
            fd.append('lang', this.importLanguage());

            fetch(`/api/v1/import/${window.auth.project.UniqueCode}/${this.entityTypeName}/${this.entityId}`, {
                method: 'POST',
                body: fd,
                credentials: 'include'
            })
                .then(resp => {
                    this.isSubmitting(false);
                    if (resp.status === 200) {
                        showToast('Import successful.')

                        this.doneCallback();
                    } else {
                        showToast('Import failed', 'error');
                    }
                }, err => {
                    this.isSubmitting(false);
                    showToast('Import failed', 'error');
                });
        }
    }
}

export default koComponent('ImportExport', ImportExport);
